import { object, string } from 'yup'

export const FUMIGADO_SCHEMA = object().shape({
  producto: string()
    .typeError('El campo debe ser texto')
    .notRequired()
    .max(8, 'Maximo de 8 caracteres'),
  observaciones: string()
    .typeError('El campo debe ser texto')
    .notRequired()

})
